const url = 'https://logger007.cam4.com/rewrite/v2/events';

const track = async({
  eventname,
  value,
  username,
  room,
  protocol,
  provider,
  logLevel,
  details,
  stackTrace,
  category,
  streamId,
  origin,
  timestamp,
}) => {

  if (!eventname) {
    return;
  }

  try {
    await window.fetch(url, {
      method: 'POST',
      headers: { 'content-type': 'application/json; charset=utf-8' },
      body: JSON.stringify({
        eventname,
        value,
        username,
        room,
        protocol,
        provider,
        logLevel,
        details,
        stackTrace,
        category,
        streamId,
        origin,
        timestamp,
      }),
    });
  } catch {
    // nothing
  }
};

export default track;
